import React, { BaseHTMLAttributes, FC, memo } from 'react'

import { ImageV2 } from '@Components/Image'
import { Link } from '@Components/Link'
import { Image } from '@Generated/graphql'

import styles from './ProductBundleItem.module.scss'

export type ProductBundleItemProps = {
  children?: React.ReactNode
  expanded?: boolean
  image?: Image
  link?: string
  onClick?: BaseHTMLAttributes<HTMLAnchorElement>['onClick']
  price?: string
  title?: string
}

export const ProductBundleItem: FC<ProductBundleItemProps> = memo(({ children, expanded, image, link, onClick, title }) => {
  const contents = (
    <div className={styles.item}>
      {image?.url && (
        <div className={styles.image}>
          <ImageV2
            alt={title}
            className={styles.image}
            height={54}
            src={image.url}
            width={54}
          />
        </div>
      )}
      {children}

      {/* Disabled according to TH-6522
      {price && <div className={styles.price}>{price}</div>} */}
    </div>
  )

  return (
    link
      ? <Link className={`${styles.wrapper} ${expanded ? '' : styles.collapsed}`} href={link} onClick={onClick}>{contents}</Link>
      : <div className={`${styles.wrapper} ${expanded ? '' : styles.collapsed}`}>{contents}</div>
  )
})
